import { Injectable } from '@angular/core';
import { IRouterState } from '../router-state';
import { BehaviorSubject } from 'rxjs';
import { SimpleReuseStrategy, ElementsService } from 'dbweb-core';
import { UrlTree, Router, NavigationEnd } from '@angular/router';
export class Tab implements IRouterState {
	url: UrlTree;
	key: string;
	title: string;
	titleObservable: BehaviorSubject<string>;
	constructor(state: IRouterState) {
		for (const key of Object.keys(state)) {
			this[key] = state[key];
		}
		this.titleObservable = new BehaviorSubject<string>(state.title);
	}
	data(): IRouterState {
		return {
			url: this.url,
			key: this.key,
			title: this.title
		};
	}
}

@Injectable({
	providedIn: 'root'
})
export class TabsService {
	tabs: Tab[] = [];
	_activeIndex?: number;
	constructor(private router: Router, private eles: ElementsService) {}
	// æ¿æ´»ä¸ä¸ªtabï¼å¦æä¸å­å¨ï¼åæ°å¢å¹¶æ¿æ´»
	activeTab(data: IRouterState) {
		const find = this.tabs.findIndex(v => v.key === data.key);
		if (find === -1) {
			this.tabs.push(new Tab(data));
			this._activeIndex = this.tabs.length - 1;
		} else {
			this._activeIndex = find;
			// åæ¶éè¦æ´æ°urlåtitle
			this.tabs[this._activeIndex].url = data.url;
			this.tabs[this._activeIndex].title = data.title;
		}
	}
	// å é¤æå®åºå·çtabï¼å¹¶åæ¢æ¿æ´»çtabï¼å¦æåªæä¸ä¸ªtabï¼åä¸è½è¢«å é¤
	// è¿åtrueæç¤ºæ¿æ´»é¡µå·²ç»åæ¢
	removeTab(index: number): boolean {
		if (this.tabs.length === 1) {
			return false;
		}
		const deleteURL = this.tabs[index].url.toString();
		// å¦ææ¯å³é­å½åé¡µé¢ï¼åä¼å¼èµ·è·¯ç±ååï¼æä»¥éè¦å¨å¯¼èªç»æäºä»¶ä¸­å é¤ï¼å ä¸ºå¯¼èªè¿ç¨ä¸­è¿ä¼è¿è¡ä¿å­
		if (index === this._activeIndex) {
			const sub = this.router.events.subscribe(v => {
				if (v instanceof NavigationEnd) {
					SimpleReuseStrategy.deleteRouteSnapshot(deleteURL);
					sub.unsubscribe();
				}
			});
		} else {
			SimpleReuseStrategy.deleteRouteSnapshot(deleteURL);
		}
		this.tabs.splice(index, 1);
		if (this._activeIndex === index) {
			this._activeIndex = Math.min(this.tabs.length - 1, index);
			return true;
		}
		if (this._activeIndex > index) {
			this._activeIndex--;
		}
		return false;
	}
	// å é¤ææçé¡µï¼ä¸è¬æ¯logout
	clear() {
		this.tabs.splice(0);
		this._activeIndex = undefined;
		SimpleReuseStrategy.clearRouteSnapshot();
	}
	// å³é­å½åé¡µï¼å¹¶èªå¨å¯¼èªå°æ°çé¡µ
	close() {
		if (this.activeIndex >= 0) {
			const idx = this.activeIndex;
			if (this.tabs.length === 1) {
				this.router.navigateByUrl(this.eles.frontElementURL(this.eles.indexElementName)).then(() => {
					this.removeTab(idx);
				});
			}
			if (this.removeTab(idx)) {
				this.router.navigateByUrl(this.active.url, {
					state: this.active.data()
				});
			}
		}
	}
	get active() {
		if (this._activeIndex >= 0) {
			return this.tabs[this._activeIndex];
		}
		return undefined;
	}
	get activeIndex() {
		return this._activeIndex;
	}
	set activeIndex(val: number) {
		this._activeIndex = val;
	}
}
